<template>
  <div id="app">
    <v-app>
      <main>
        <router-view />
      </main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style>
@import url("../src/css/IranSansFont.css");

* {
  font-family: IranSans
}
</style>
